<template>
  <button-line
    :items="[
      {
        label: $ucfirst($t(afterFirstEncounter ? 'journeyProgress.progress' : 'journeyBehaviourChangeGoals.status')),
        route: {
          name: afterFirstEncounter ? 'PatientRecordMedicationProgress' : 'PatientRecordMedicationStatus',
          params: { patientId },
        },
      },
      {
        label: $ucfirst($t('medication.prescription')),
        route: {
          name: 'PatientRecordMedicationPrescription',
          params: { patientId },
        },
      }
    ]"
    v-bind="$attrs"
  />
</template>

<script>
import { mapGetters } from 'vuex';
import ButtonLine from "./ButtonLine";

/**
 * Component MedicationButtonLine.vue
 *
 * @module MedicationButtonLine
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.6] app/src/APP_DASHBOARD/templates/components/Parts/MedicationButtonLine.vue
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export default {
  name: "MedicationButtonLine",
  components: {
    ButtonLine,
  },
  computed: {
    ...mapGetters({
      patientId: 'patientSummary/id',
    }),
    afterFirstEncounter() {
      return parseInt(this.$store.getters['patientSummary/currentVersion']) > 2
    }
  }
};
</script>

<style lang="scss">
</style>
